module.exports = __webpack_public_path__ + "img/ringed-planet.d967f24e.svg";